export default __webpack_public_path__ + "static/illustration-card-one.url-9d60ff5d2f447e7b62bc9b327401e5aa.svg";